import React, { Component } from 'react';
import DataAPI from '../../../Utils/Api';
import TimeUtil from '../../../Utils/TimeUtil';

interface IState {
    polls
    pollSelected
}

class Polls extends Component<{}, IState> {
    constructor(props) {
        super(props);
        this.state = {
            polls: [],
            pollSelected: ""
        }
    }

    getAllPolls = () => {
        DataAPI().post('/GetPolls',{})
        .then((response) => {
            this.setState({ polls: response.data })
        })
        .catch((error) => {
            console.log(error);
        })
    }

    componentDidMount() {
        //this.getAllPolls();
    }

    handlePollAnsChange = (e) => {
        if (e.target.type === "radio") {
            var poll = e.target.value;
            this.setState({
                pollSelected: poll
            });
        }
    };

    pollSubmit(pollID, userID) {
        DataAPI().post('/DeletePolls',{
            userId : userID,
            pollId: pollID.toString(),
            pollOptionsId: this.state.pollSelected
        })
        .then((response) => {
            if (response.data.response === "Success") {
                this.getAllPolls();
            }
        })
        .catch((error) => {
            console.log(error);
        })
    }


    render() {
        return (
            <React.Fragment>
                <span style={{ color: "#367feb", fontSize: "15px" }}>({this.state.polls.length})</span>
                {this.state.polls.map((e, i) => {
                    return (
                        <div className="sf-each-offer" key={i}>
                            
                            <b style={{ fontSize: "13px" }}>
                                {e.polls_title}
                            </b>
                            <hr/>
                            <b style={{ fontSize: "13px" }}>
                                {e.poll_question}
                            </b>
                            <br />
                                {e.pollsResponseDtos.map((opt, index) => {
                                    return (
                                        <div style={{marginLeft: "20px"}} key={index}>
                                            <b style={{ fontSize: "13px" }}>
                                                {opt.poll_question}
                                            </b>
                                            <br />
                                            <span style={{ fontSize: "12px", color: "#6e6e6e" }}>
                                                <input
                                                    type="radio"
                                                    value={opt.polls_option_id}
                                                    id="polls"
                                                    name="radio"
                                                    onChange={this.handlePollAnsChange}
                                                />
                                                <span style={{ fontSize: "15px", color: "#6e6e6e" }}>
                                                    {opt.polls_option}
                                                </span>
                                                
                                            </span>
                                            <br />
                                        </div>
                                    );
                                })}
                                <br />
                                <button
                                    className="poll-submit-button"
                                    onClick={this.pollSubmit.bind(this, e.polls_id, e.userId)}
                                >
                                    Submit
                                </button>
                            
                            <span style={{ fontSize: "8px", float: "right" }}>{TimeUtil.getCurrentTime(new Date())}</span>
                        </div>
                    )
                })}
            </React.Fragment>
        );
    }
}

export default Polls;